// import React, { useState, useEffect } from "react";

// const VendorQuotations = () => {
//     const [quotations, setQuotations] = useState([]);
//     const [filter, setFilter] = useState("all");
//     const [selectedQuotation, setSelectedQuotation] = useState(null);
//     const [showPopup, setShowPopup] = useState(false);


//     useEffect(() => {

//         const mockQuotations = [
//             {
//                 id: 1,
//                 enquiryId: 63,
//                 vendorId: 101,
//                 vendorName: "Fresh Foods Catering",
//                 status: "accepted",
//                 quotationDate: "20/02/2026",
//                 validUntil: "25/02/2026",
//                 vegPerPlatePrice: 350,
//                 nonVegPerPlatePrice: 450,
//                 mixedPerPlatePrice: 400,
//                 quotationDetails: "Includes all menu items with premium ingredients. Special discount for bulk order.",
//                 addOnPrices: [
//                     {
//                         addOnId: 1,
//                         addOnType: "EXTRA_STARTER",
//                         quantity: 2,
//                         price: 500,
//                         totalAmount: 1000
//                     },
//                     {
//                         addOnId: 2,
//                         addOnType: "DESSERT_COUNTER",
//                         quantity: 1,
//                         price: 800,
//                         totalAmount: 800
//                     }
//                 ]
//             },
//             {
//                 id: 2,
//                 enquiryId: 63,
//                 vendorId: 102,
//                 vendorName: "Spice Garden",
//                 status: "pending",
//                 quotationDate: "21/02/2026",
//                 validUntil: "26/02/2026",
//                 vegPerPlatePrice: 320,
//                 nonVegPerPlatePrice: 420,
//                 mixedPerPlatePrice: 370,
//                 quotationDetails: "Competitive pricing with authentic spices. Includes complimentary welcome drink.",
//                 addOnPrices: [
//                     {
//                         addOnId: 3,
//                         addOnType: "LIVE_COUNTER",
//                         quantity: 1,
//                         price: 1200,
//                         totalAmount: 1200
//                     }
//                 ]
//             },
//             {
//                 id: 3,
//                 enquiryId: 63,
//                 vendorId: 104,
//                 vendorName: "Urban Tadka Caterers",
//                 status: "rejected",
//                 quotationDate: "19/02/2026",
//                 validUntil: "24/02/2026",
//                 vegPerPlatePrice: 380,
//                 nonVegPerPlatePrice: 480,
//                 mixedPerPlatePrice: 430,
//                 quotationDetails: "Premium package with additional items. Includes decorative food displays.",
//                 addOnPrices: [
//                     {
//                         addOnId: 4,
//                         addOnType: "DECORATIVE_SETUP",
//                         quantity: 1,
//                         price: 1500,
//                         totalAmount: 1500
//                     },
//                     {
//                         addOnId: 5,
//                         addOnType: "SPECIAL_DESSERT",
//                         quantity: 3,
//                         price: 200,
//                         totalAmount: 600
//                     }
//                 ]
//             },
//             {
//                 id: 4,
//                 enquiryId: 64,
//                 vendorId: 101,
//                 vendorName: "Fresh Foods Catering",
//                 status: "accepted",
//                 quotationDate: "22/02/2026",
//                 validUntil: "27/02/2026",
//                 vegPerPlatePrice: 340,
//                 nonVegPerPlatePrice: 440,
//                 mixedPerPlatePrice: 390,
//                 quotationDetails: "Wedding special menu with dessert counter. Includes staff service.",
//                 addOnPrices: [
//                     {
//                         addOnId: 6,
//                         addOnType: "STAFF_SERVICE",
//                         quantity: 4,
//                         price: 300,
//                         totalAmount: 1200
//                     },
//                     {
//                         addOnId: 7,
//                         addOnType: "BEVERAGE_COUNTER",
//                         quantity: 1,
//                         price: 1000,
//                         totalAmount: 1000
//                     }
//                 ]
//             },
//             {
//                 id: 5,
//                 enquiryId: 64,
//                 vendorId: 105,
//                 vendorName: "Grand Feast Events",
//                 status: "pending",
//                 quotationDate: "23/02/2026",
//                 validUntil: "28/02/2026",
//                 vegPerPlatePrice: 330,
//                 nonVegPerPlatePrice: 430,
//                 mixedPerPlatePrice: 380,
//                 quotationDetails: "Competitive pricing for wedding event. Includes complimentary cake cutting.",
//                 addOnPrices: []
//             },
//             {
//                 id: 6,
//                 enquiryId: 65,
//                 vendorId: 103,
//                 vendorName: "Royal Dine Services",
//                 status: "pending",
//                 quotationDate: "18/02/2026",
//                 validUntil: "23/02/2026",
//                 vegPerPlatePrice: 300,
//                 nonVegPerPlatePrice: 400,
//                 mixedPerPlatePrice: 350,
//                 quotationDetails: "Basic package with standard items. Economical option for small events.",
//                 addOnPrices: [
//                     {
//                         addOnId: 8,
//                         addOnType: "EXTRA_DESSERT",
//                         quantity: 2,
//                         price: 150,
//                         totalAmount: 300
//                     }
//                 ]
//             }
//         ];

//         setQuotations(mockQuotations);
//     }, []);

//     // Format currency
//     const formatCurrency = (amount) => {
//         return `₹${parseInt(amount).toLocaleString('en-IN')}`;
//     };

//     // Format date
//     const formatDate = (dateString) => {
//         if (!dateString) return "N/A";
//         return dateString;
//     };

//     // Calculate total quotation amount
//     const calculateTotalQuotation = (quotation) => {
//         // Calculate plates total based on actual order counts (this would come from order data)
//         // For demo purposes, assuming 100 plates total
//         const vegPlates = 80;
//         const nonVegPlates = 10;
//         const mixedPlates = 10;

//         const platesTotal = (vegPlates * quotation.vegPerPlatePrice) +
//             (nonVegPlates * quotation.nonVegPerPlatePrice) +
//             (mixedPlates * quotation.mixedPerPlatePrice);

//         const addOnsTotal = quotation.addOnPrices.reduce((sum, addon) => sum + addon.totalAmount, 0);

//         return platesTotal + addOnsTotal;
//     };

//     // Get filtered quotations based on status
//     const getFilteredQuotations = () => {
//         switch (filter) {
//             case "pending":
//                 return quotations.filter(q => q.status === "pending");
//             case "accepted":
//                 return quotations.filter(q => q.status === "accepted");
//             case "rejected":
//                 return quotations.filter(q => q.status === "rejected");
//             default:
//                 return quotations;
//         }
//     };

//     // Get statistics
//     const getStatistics = () => {
//         const total = quotations.length;
//         const pending = quotations.filter(q => q.status === "pending").length;
//         const accepted = quotations.filter(q => q.status === "accepted").length;
//         const rejected = quotations.filter(q => q.status === "rejected").length;

//         return { total, pending, accepted, rejected };
//     };

//     // Handle filter change
//     const handleFilterChange = (e) => {
//         setFilter(e.target.value);
//     };

//     // Get status badge style
//     const getStatusBadge = (status) => {
//         switch (status) {
//             case "accepted":
//                 return {
//                     backgroundColor: "#d4edda",
//                     color: "#155724",
//                     padding: "4px 8px",
//                     borderRadius: "12px",
//                     fontSize: "11px",
//                     fontWeight: "bold",
//                     display: "inline-block"
//                 };
//             case "pending":
//                 return {
//                     backgroundColor: "#fff3cd",
//                     color: "#856404",
//                     padding: "4px 8px",
//                     borderRadius: "12px",
//                     fontSize: "11px",
//                     fontWeight: "bold",
//                     display: "inline-block"
//                 };
//             case "rejected":
//                 return {
//                     backgroundColor: "#f8d7da",
//                     color: "#721c24",
//                     padding: "4px 8px",
//                     borderRadius: "12px",
//                     fontSize: "11px",
//                     fontWeight: "bold",
//                     display: "inline-block"
//                 };
//             default:
//                 return {};
//         }
//     };

//     // Styles
//     const styles = {
//         container: {
//             padding: "20px",
//             backgroundColor: "#f5f5f5",
//             minHeight: "100vh",
//             width: "100%",
//             boxSizing: "border-box"
//         },
//         header: {
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             marginBottom: "20px",
//             flexDirection: window.innerWidth < 768 ? "column" : "row",
//             gap: "15px"
//         },
//         title: {
//             fontSize: window.innerWidth < 768 ? "20px" : "24px",
//             fontWeight: "bold",
//             color: "#333",
//             margin: 0,
//             textAlign: window.innerWidth < 768 ? "center" : "left"
//         },
//         filterContainer: {
//             display: "flex",
//             gap: "10px",
//             flexWrap: "wrap",
//             justifyContent: "center",
//             alignItems: "center"
//         },
//         filterLabel: {
//             fontSize: "14px",
//             fontWeight: "bold",
//             color: "#666"
//         },
//         filterSelect: {
//             padding: "10px 16px",
//             border: "1px solid #ddd",
//             borderRadius: "5px",
//             fontSize: "14px",
//             backgroundColor: "white",
//             cursor: "pointer",
//             minWidth: "180px",
//             outline: "none",
//             transition: "border-color 0.3s ease",
//             ":focus": {
//                 borderColor: "rgb(230 109 51)"
//             }
//         },
//         statsContainer: {
//             display: "flex",
//             gap: window.innerWidth < 768 ? "10px" : "20px",
//             flexWrap: "wrap",
//             marginBottom: "20px",
//             padding: "15px",
//             backgroundColor: "white",
//             borderRadius: "8px",
//             boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
//         },
//         statItem: {
//             display: "flex",
//             alignItems: "center",
//             gap: "5px"
//         },
//         statBadge: {
//             padding: "4px 8px",
//             borderRadius: "12px",
//             fontSize: "11px",
//             fontWeight: "bold",
//             whiteSpace: "nowrap"
//         },
//         tableContainer: {
//             width: "100%",
//             overflowX: "auto",
//             borderRadius: "8px",
//             border: "1px solid #ddd",
//             backgroundColor: "white"
//         },
//         table: {
//             width: "100%",
//             borderCollapse: "collapse",
//             minWidth: "1000px"
//         },
//         tableHeader: {
//             backgroundColor: "rgb(230 109 51)",
//             color: "white",
//             padding: "12px",
//             textAlign: "left",
//             fontSize: window.innerWidth < 768 ? "12px" : "14px",
//             whiteSpace: "nowrap"
//         },
//         tableCell: {
//             padding: window.innerWidth < 768 ? "8px" : "12px",
//             borderBottom: "1px solid #ddd",
//             fontSize: window.innerWidth < 768 ? "12px" : "14px"
//         },
//         quotationCell: {
//             padding: window.innerWidth < 768 ? "8px" : "12px",
//             borderBottom: "1px solid #ddd",
//             fontSize: window.innerWidth < 768 ? "12px" : "14px",
//             fontWeight: "bold",
//             color: "rgb(230 109 51)"
//         },
//         viewButton: {
//             backgroundColor: "rgb(230 109 51)",
//             color: "white",
//             border: "none",
//             padding: "5px 10px",
//             borderRadius: "4px",
//             cursor: "pointer",
//             fontSize: "12px",
//             fontWeight: "bold"
//         },
//         // Popup styles
//         overlay: {
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: "rgba(0, 0, 0, 0.5)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 10001
//         },
//         popup: {
//             backgroundColor: "white",
//             borderRadius: "10px",
//             padding: "25px",
//             maxWidth: "800px",
//             width: "90%",
//             maxHeight: "90vh",
//             overflowY: "auto",
//             boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
//             position: "relative"
//         },
//         popupHeader: {
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             marginBottom: "20px",
//             paddingBottom: "10px",
//             borderBottom: "2px solid rgb(230 109 51)"
//         },
//         popupTitle: {
//             fontSize: "20px",
//             fontWeight: "bold",
//             color: "#333",
//             margin: 0
//         },
//         closeButton: {
//             background: "none",
//             border: "none",
//             fontSize: "24px",
//             cursor: "pointer",
//             color: "#666",
//             padding: "0 10px"
//         },
//         priceGrid: {
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
//             gap: "15px",
//             marginBottom: "20px"
//         },
//         priceCard: {
//             padding: "15px",
//             backgroundColor: "#f8f9fa",
//             borderRadius: "6px",
//             border: "1px solid #dee2e6"
//         },
//         priceLabel: {
//             fontSize: "13px",
//             color: "#666",
//             marginBottom: "5px"
//         },
//         priceValue: {
//             fontSize: "18px",
//             fontWeight: "bold",
//             color: "rgb(230 109 51)"
//         },
//         sectionTitle: {
//             color: "rgb(230 109 51)",
//             marginBottom: "10px",
//             fontSize: "16px",
//             fontWeight: "bold"
//         },
//         detailsText: {
//             padding: "10px",
//             backgroundColor: "#f8f9fa",
//             borderRadius: "6px",
//             marginBottom: "20px"
//         },
//         addOnsTable: {
//             width: "100%",
//             borderCollapse: "collapse",
//             marginTop: "10px"
//         },
//         addOnsHeader: {
//             backgroundColor: "#e9ecef",
//             padding: "10px",
//             textAlign: "left",
//             fontSize: "13px",
//             fontWeight: "bold"
//         },
//         addOnsCell: {
//             padding: "8px",
//             borderBottom: "1px solid #dee2e6",
//             fontSize: "13px"
//         }
//     };

//     const stats = getStatistics();
//     const filteredQuotations = getFilteredQuotations();

//     return (
//         <div style={styles.container}>
//             {/* Header with filters */}
//             <div style={styles.header}>

//                 <div style={styles.filterContainer}>
//                     <label htmlFor="filter-select" style={styles.filterLabel}>
//                         Filter by:
//                     </label>
//                     <select
//                         id="filter-select"
//                         value={filter}
//                         onChange={handleFilterChange}
//                         style={styles.filterSelect}
//                     >
//                         <option value="all">All Quotations ({stats.total})</option>
//                         <option value="pending">Pending ({stats.pending})</option>
//                         <option value="accepted">Accepted ({stats.accepted})</option>
//                         <option value="rejected">Rejected ({stats.rejected})</option>
//                     </select>
//                 </div>
//             </div>

//             {/* Statistics Cards */}
//             <div style={styles.statsContainer}>
//                 <div style={styles.statItem}>
//                     <span style={{ color: "#666", fontSize: window.innerWidth < 768 ? "12px" : "14px" }}>Total Quotations:</span>
//                     <span style={{ fontWeight: "bold", fontSize: window.innerWidth < 768 ? "12px" : "14px" }}>{stats.total}</span>
//                 </div>
//                 <div style={styles.statItem}>
//                     <span style={{ ...styles.statBadge, backgroundColor: "#fff3cd", color: "#856404" }}>
//                         Pending: {stats.pending}
//                     </span>
//                 </div>
//                 <div style={styles.statItem}>
//                     <span style={{ ...styles.statBadge, backgroundColor: "#d4edda", color: "#155724" }}>
//                         Accepted: {stats.accepted}
//                     </span>
//                 </div>
//                 <div style={styles.statItem}>
//                     <span style={{ ...styles.statBadge, backgroundColor: "#f8d7da", color: "#721c24" }}>
//                         Rejected: {stats.rejected}
//                     </span>
//                 </div>
//             </div>

//             {/* Main Table with Enquiry ID, Vendor ID, and Quotation */}
//             <div style={styles.tableContainer}>
//                 <table style={styles.table}>
//                     <thead>
//                         <tr>
//                             <th style={styles.tableHeader}>Enquiry ID</th>
//                             <th style={styles.tableHeader}>Vendor ID</th>
//                             <th style={styles.tableHeader}>Vendor Name</th>
//                             <th style={styles.tableHeader}>Veg/Plate</th>
//                             <th style={styles.tableHeader}>Non-Veg/Plate</th>
//                             {/* <th style={styles.tableHeader}>Mixed/Plate</th> */}
//                             <th style={styles.tableHeader}>Total Quotation</th>
//                             <th style={styles.tableHeader}>Status</th>
//                             <th style={styles.tableHeader}>Quotation Date</th>
//                             <th style={styles.tableHeader}>Valid Until</th>
//                             <th style={styles.tableHeader}>Action</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {filteredQuotations.map((quotation) => (
//                             <tr key={quotation.id}>
//                                 <td style={styles.tableCell}>
//                                     <strong>#{quotation.enquiryId}</strong>
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     <strong>#{quotation.vendorId}</strong>
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     {quotation.vendorName}
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     {formatCurrency(quotation.vegPerPlatePrice)}
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     {formatCurrency(quotation.nonVegPerPlatePrice)}
//                                 </td>
//                                 {/* <td style={styles.tableCell}>
//                                     {formatCurrency(quotation.mixedPerPlatePrice)}
//                                 </td> */}
//                                 <td style={styles.quotationCell}>
//                                     {formatCurrency(calculateTotalQuotation(quotation))}
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     <span style={getStatusBadge(quotation.status)}>
//                                         {quotation.status.charAt(0).toUpperCase() + quotation.status.slice(1)}
//                                     </span>
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     {formatDate(quotation.quotationDate)}
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     {formatDate(quotation.validUntil)}
//                                 </td>
//                                 <td style={styles.tableCell}>
//                                     <button
//                                         style={styles.viewButton}
//                                         onClick={() => {
//                                             setSelectedQuotation(quotation);
//                                             setShowPopup(true);
//                                         }}
//                                     >
//                                         View Details
//                                     </button>
//                                 </td>
//                             </tr>
//                         ))}
//                         {filteredQuotations.length === 0 && (
//                             <tr>
//                                 <td colSpan="11" style={{ textAlign: "center", padding: "20px", color: "#666" }}>
//                                     No quotations match the selected filter
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Popup for Quotation Details */}
//             {showPopup && selectedQuotation && (
//                 <div style={styles.overlay} onClick={() => setShowPopup(false)}>
//                     <div style={styles.popup} onClick={(e) => e.stopPropagation()}>
//                         <div style={styles.popupHeader}>
//                             <h3 style={styles.popupTitle}>
//                                 Quotation Details - Enquiry #{selectedQuotation.enquiryId}
//                             </h3>
//                             <button
//                                 style={styles.closeButton}
//                                 onClick={() => setShowPopup(false)}
//                             >
//                                 ×
//                             </button>
//                         </div>

//                         <div style={{ marginBottom: "15px" }}>
//                             <strong>Vendor:</strong> #{selectedQuotation.vendorId} - {selectedQuotation.vendorName}
//                         </div>

//                         {/* Per Plate Prices */}
//                         <div style={styles.priceGrid}>
//                             <div style={styles.priceCard}>
//                                 <div style={styles.priceLabel}>Veg Per Plate</div>
//                                 <div style={styles.priceValue}>{formatCurrency(selectedQuotation.vegPerPlatePrice)}</div>
//                             </div>
//                             <div style={styles.priceCard}>
//                                 <div style={styles.priceLabel}>Non-Veg Per Plate</div>
//                                 <div style={styles.priceValue}>{formatCurrency(selectedQuotation.nonVegPerPlatePrice)}</div>
//                             </div>
//                             {/* <div style={styles.priceCard}>
//                                 <div style={styles.priceLabel}>Mixed Per Plate</div>
//                                 <div style={styles.priceValue}>{formatCurrency(selectedQuotation.mixedPerPlatePrice)}</div>
//                             </div> */}
//                             <div style={styles.priceCard}>
//                                 <div style={styles.priceLabel}>Total Amount</div>
//                                 <div style={styles.priceValue}>{formatCurrency(calculateTotalQuotation(selectedQuotation))}</div>
//                             </div>
//                         </div>

//                         {/* Quotation Details */}
//                         <div style={{ marginBottom: "20px" }}>
//                             <h4 style={styles.sectionTitle}>Quotation Details</h4>
//                             <div style={styles.detailsText}>
//                                 {selectedQuotation.quotationDetails}
//                             </div>
//                         </div>

//                         {/* Add-On Prices */}
//                         {selectedQuotation.addOnPrices.length > 0 && (
//                             <div>
//                                 <h4 style={styles.sectionTitle}>Add-Ons</h4>
//                                 <table style={styles.addOnsTable}>
//                                     <thead>
//                                         <tr>
//                                             <th style={styles.addOnsHeader}>Add-On ID</th>
//                                             <th style={styles.addOnsHeader}>Add-On Type</th>
//                                             <th style={styles.addOnsHeader}>Qty</th>
//                                             <th style={styles.addOnsHeader}>Unit Price</th>
//                                             <th style={styles.addOnsHeader}>Total</th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {selectedQuotation.addOnPrices.map((addon, index) => (
//                                             <tr key={index}>
//                                                 <td style={styles.addOnsCell}>#{addon.addOnId}</td>
//                                                 <td style={styles.addOnsCell}>
//                                                     {addon.addOnType.split('_').map(word =>
//                                                         word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
//                                                     ).join(' ')}
//                                                 </td>
//                                                 <td style={styles.addOnsCell}>{addon.quantity}</td>
//                                                 <td style={styles.addOnsCell}>{formatCurrency(addon.price)}</td>
//                                                 <td style={styles.addOnsCell}>{formatCurrency(addon.totalAmount)}</td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         )}

//                         {/* Close button at bottom */}
//                         <div style={{ textAlign: "center", marginTop: "20px" }}>
//                             <button
//                                 style={{
//                                     backgroundColor: "rgb(230 109 51)",
//                                     color: "white",
//                                     border: "none",
//                                     padding: "10px 30px",
//                                     borderRadius: "5px",
//                                     cursor: "pointer",
//                                     fontWeight: "bold"
//                                 }}
//                                 onClick={() => setShowPopup(false)}
//                             >
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default VendorQuotations;






import React, { useState, useEffect } from "react";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Filter: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3"/>
        </svg>
    ),
    Check: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12"/>
        </svg>
    ),
    X: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Calendar: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
    ),
    Vendor: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
        </svg>
    ),
    Money: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M8 12h8"/>
            <path d="M12 8v8"/>
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2"/>
            <line x1="8" y1="21" x2="16" y2="21"/>
            <line x1="12" y1="17" x2="12" y2="21"/>
            <path d="M8 7h8M8 11h6M8 15h4"/>
        </svg>
    ),
    Enquiry: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 6v6l4 2"/>
        </svg>
    ),
    Veg: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 6v6l4 2"/>
        </svg>
    ),
    NonVeg: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d32f2f" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="8" y1="8" x2="16" y2="16"/>
            <line x1="16" y1="8" x2="8" y2="16"/>
        </svg>
    ),
    AddOn: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"/>
            <path d="M2 17l10 5 10-5"/>
            <path d="M2 12l10 5 10-5"/>
        </svg>
    ),
    Close: () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Total: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 12h-4l-3 9-4-18-3 9H2"/>
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',
      
        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '12px',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    filterGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        flexWrap: 'wrap'
    },
    filterLabel: {
        fontSize: '13px',
        fontWeight: '500',
        color: '#4a5568'
    },
    filterSelect: {
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '40px',
        minWidth: '180px',
        cursor: 'pointer'
    },
    statsContainer: {
        display: 'flex',
        gap: '12px',
        flexWrap: 'wrap',
        padding: '16px 0',
        borderBottom: '1px solid #edf2f7',
        marginBottom: '16px'
    },
    statCard: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 16px',
        background: 'white',
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
        transition: 'all 0.2s ease'
    },
    statIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    statIconTotal: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    statIconPending: {
        background: '#fefcbf',
        color: '#856404'
    },
    statIconAccepted: {
        background: '#c6f6d5',
        color: '#155724'
    },
    statIconRejected: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    statContent: {
        display: 'flex',
        flexDirection: 'column'
    },
    statValue: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#2d3748',
        lineHeight: '1.2'
    },
    statLabel: {
        fontSize: '11px',
        fontWeight: '500',
        color: '#718096',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    tableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '500px',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1100px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 14px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 14px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        verticalAlign: 'middle'
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '500',
        letterSpacing: '0.3px'
    },
    badgeAccepted: {
        background: '#c6f6d5',
        color: '#155724'
    },
    badgePending: {
        background: '#fefcbf',
        color: '#856404'
    },
    badgeRejected: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    priceCell: {
        fontWeight: '600',
        color: 'rgb(230 109 51)'
    },
    viewButton: {
        padding: '4px 14px',
        borderRadius: '6px',
        border: 'none',
        background: 'rgb(230 109 51)',
        color: 'white',
        fontWeight: '600',
        fontSize: '12px',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    },
    // Popup Styles
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        padding: '20px',
        animation: 'fadeIn 0.3s ease'
    },
    popup: {
        background: 'white',
        borderRadius: '16px',
        padding: '28px',
        maxWidth: '800px',
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        animation: 'slideUp 0.3s ease'
    },
    popupHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
        paddingBottom: '12px',
        borderBottom: '2px solid rgb(230 109 51)'
    },
    popupTitle: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#2d3748',
        margin: 0
    },
    closeButton: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#a0aec0',
        padding: '4px',
        transition: 'color 0.2s ease'
    },
    priceGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: '12px',
        marginBottom: '20px'
    },
    priceCard: {
        padding: '14px 16px',
        background: '#f7fafc',
        borderRadius: '8px',
        border: '1px solid #edf2f7'
    },
    priceLabel: {
        fontSize: '12px',
        color: '#718096',
        fontWeight: '500',
        marginBottom: '4px'
    },
    priceValue: {
        fontSize: '18px',
        fontWeight: '700',
        color: 'rgb(230 109 51)'
    },
    sectionTitle: {
        color: 'rgb(230 109 51)',
        marginBottom: '10px',
        fontSize: '15px',
        fontWeight: '600',
        borderBottom: '2px solid rgb(230 109 51)',
        paddingBottom: '6px'
    },
    detailsBox: {
        padding: '12px 16px',
        background: '#f7fafc',
        borderRadius: '8px',
        marginBottom: '20px',
        border: '1px solid #edf2f7',
        color: '#2d3748',
        fontSize: '14px'
    },
    addOnsTable: {
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '8px',
        fontSize: '13px'
    },
    addOnsHeader: {
        background: '#edf2f7',
        color: '#4a5568',
        padding: '8px 12px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '12px',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    addOnsCell: {
        padding: '8px 12px',
        borderBottom: '1px solid #edf2f7'
    },
    closePopupButton: {
        display: 'block',
        width: '100%',
        padding: '10px',
        background: 'rgb(230 109 51)',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        marginTop: '16px'
    },
    vendorInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 12px',
        background: '#f0f4ff',
        borderRadius: '6px',
        marginBottom: '16px'
    }
};

const VendorQuotations = () => {
    const [quotations, setQuotations] = useState([]);
    const [filter, setFilter] = useState("all");
    const [selectedQuotation, setSelectedQuotation] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const mockQuotations = [
            {
                id: 1,
                enquiryId: 63,
                vendorId: 101,
                vendorName: "Fresh Foods Catering",
                status: "accepted",
                quotationDate: "20/02/2026",
                validUntil: "25/02/2026",
                vegPerPlatePrice: 350,
                nonVegPerPlatePrice: 450,
                mixedPerPlatePrice: 400,
                quotationDetails: "Includes all menu items with premium ingredients. Special discount for bulk order.",
                addOnPrices: [
                    { addOnId: 1, addOnType: "EXTRA_STARTER", quantity: 2, price: 500, totalAmount: 1000 },
                    { addOnId: 2, addOnType: "DESSERT_COUNTER", quantity: 1, price: 800, totalAmount: 800 }
                ]
            },
            {
                id: 2,
                enquiryId: 63,
                vendorId: 102,
                vendorName: "Spice Garden",
                status: "pending",
                quotationDate: "21/02/2026",
                validUntil: "26/02/2026",
                vegPerPlatePrice: 320,
                nonVegPerPlatePrice: 420,
                mixedPerPlatePrice: 370,
                quotationDetails: "Competitive pricing with authentic spices. Includes complimentary welcome drink.",
                addOnPrices: [
                    { addOnId: 3, addOnType: "LIVE_COUNTER", quantity: 1, price: 1200, totalAmount: 1200 }
                ]
            },
            {
                id: 3,
                enquiryId: 63,
                vendorId: 104,
                vendorName: "Urban Tadka Caterers",
                status: "rejected",
                quotationDate: "19/02/2026",
                validUntil: "24/02/2026",
                vegPerPlatePrice: 380,
                nonVegPerPlatePrice: 480,
                mixedPerPlatePrice: 430,
                quotationDetails: "Premium package with additional items. Includes decorative food displays.",
                addOnPrices: [
                    { addOnId: 4, addOnType: "DECORATIVE_SETUP", quantity: 1, price: 1500, totalAmount: 1500 },
                    { addOnId: 5, addOnType: "SPECIAL_DESSERT", quantity: 3, price: 200, totalAmount: 600 }
                ]
            },
            {
                id: 4,
                enquiryId: 64,
                vendorId: 101,
                vendorName: "Fresh Foods Catering",
                status: "accepted",
                quotationDate: "22/02/2026",
                validUntil: "27/02/2026",
                vegPerPlatePrice: 340,
                nonVegPerPlatePrice: 440,
                mixedPerPlatePrice: 390,
                quotationDetails: "Wedding special menu with dessert counter. Includes staff service.",
                addOnPrices: [
                    { addOnId: 6, addOnType: "STAFF_SERVICE", quantity: 4, price: 300, totalAmount: 1200 },
                    { addOnId: 7, addOnType: "BEVERAGE_COUNTER", quantity: 1, price: 1000, totalAmount: 1000 }
                ]
            },
            {
                id: 5,
                enquiryId: 64,
                vendorId: 105,
                vendorName: "Grand Feast Events",
                status: "pending",
                quotationDate: "23/02/2026",
                validUntil: "28/02/2026",
                vegPerPlatePrice: 330,
                nonVegPerPlatePrice: 430,
                mixedPerPlatePrice: 380,
                quotationDetails: "Competitive pricing for wedding event. Includes complimentary cake cutting.",
                addOnPrices: []
            },
            {
                id: 6,
                enquiryId: 65,
                vendorId: 103,
                vendorName: "Royal Dine Services",
                status: "pending",
                quotationDate: "18/02/2026",
                validUntil: "23/02/2026",
                vegPerPlatePrice: 300,
                nonVegPerPlatePrice: 400,
                mixedPerPlatePrice: 350,
                quotationDetails: "Basic package with standard items. Economical option for small events.",
                addOnPrices: [
                    { addOnId: 8, addOnType: "EXTRA_DESSERT", quantity: 2, price: 150, totalAmount: 300 }
                ]
            }
        ];

        setQuotations(mockQuotations);
    }, []);

    const formatCurrency = (amount) => `₹${parseInt(amount).toLocaleString('en-IN')}`;
    const formatDate = (dateString) => dateString || "N/A";

    const calculateTotalQuotation = (quotation) => {
        const vegPlates = 80;
        const nonVegPlates = 10;
        const mixedPlates = 10;

        const platesTotal = (vegPlates * quotation.vegPerPlatePrice) +
            (nonVegPlates * quotation.nonVegPerPlatePrice) +
            (mixedPlates * quotation.mixedPerPlatePrice);

        const addOnsTotal = quotation.addOnPrices.reduce((sum, addon) => sum + addon.totalAmount, 0);
        return platesTotal + addOnsTotal;
    };

    const getFilteredQuotations = () => {
        switch (filter) {
            case "pending": return quotations.filter(q => q.status === "pending");
            case "accepted": return quotations.filter(q => q.status === "accepted");
            case "rejected": return quotations.filter(q => q.status === "rejected");
            default: return quotations;
        }
    };

    const getStatistics = () => {
        const total = quotations.length;
        const pending = quotations.filter(q => q.status === "pending").length;
        const accepted = quotations.filter(q => q.status === "accepted").length;
        const rejected = quotations.filter(q => q.status === "rejected").length;
        return { total, pending, accepted, rejected };
    };

    const handleFilterChange = (e) => setFilter(e.target.value);

    const getStatusBadge = (status) => {
        switch (status) {
            case "accepted": return styles.badgeAccepted;
            case "pending": return styles.badgePending;
            case "rejected": return styles.badgeRejected;
            default: return {};
        }
    };

    const getStatusLabel = (status) => {
        return status.charAt(0).toUpperCase() + status.slice(1);
    };

    const stats = getStatistics();
    const filteredQuotations = getFilteredQuotations();

    return (
        <div style={styles.container}>
            {/* Header */}
            

            {/* Stats Cards */}
            <div style={styles.statsContainer}>
                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconTotal }}>
                        <Icons.Total />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{stats.total}</span>
                        <span style={styles.statLabel}>Total Quotations</span>
                    </div>
                </div>

                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconPending }}>
                        <Icons.Check />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{stats.pending}</span>
                        <span style={styles.statLabel}>Pending</span>
                    </div>
                </div>

                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconAccepted }}>
                        <Icons.Check />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{stats.accepted}</span>
                        <span style={styles.statLabel}>Accepted</span>
                    </div>
                </div>

                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconRejected }}>
                        <Icons.X />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{stats.rejected}</span>
                        <span style={styles.statLabel}>Rejected</span>
                    </div>
                </div>
            </div>

            {/* Table */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={styles.th}>Enquiry ID</th>
                            <th style={styles.th}>Vendor ID</th>
                            <th style={styles.th}>Vendor Name</th>
                            <th style={styles.th}>Veg/Plate</th>
                            <th style={styles.th}>Non-Veg/Plate</th>
                            <th style={styles.th}>Total Quotation</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Status</th>
                            <th style={styles.th}>Quotation Date</th>
                            <th style={styles.th}>Valid Until</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredQuotations.length > 0 ? (
                            filteredQuotations.map((quotation, index) => (
                                <tr
                                    key={quotation.id}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                        transition: 'background 0.15s ease'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                >
                                    <td style={{ ...styles.td, fontWeight: '600', color: 'rgb(230 109 51)' }}>
                                        #{quotation.enquiryId}
                                    </td>
                                    <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>
                                        #{quotation.vendorId}
                                    </td>
                                    <td style={{ ...styles.td, fontWeight: '500' }}>
                                        {quotation.vendorName}
                                    </td>
                                    <td style={styles.td}>
                                        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <Icons.Veg /> {formatCurrency(quotation.vegPerPlatePrice)}
                                        </span>
                                    </td>
                                    <td style={styles.td}>
                                        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <Icons.NonVeg /> {formatCurrency(quotation.nonVegPerPlatePrice)}
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, ...styles.priceCell }}>
                                        {formatCurrency(calculateTotalQuotation(quotation))}
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <span style={{ ...styles.badge, ...getStatusBadge(quotation.status) }}>
                                            {getStatusLabel(quotation.status)}
                                        </span>
                                    </td>
                                    <td style={styles.td}>
                                        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <Icons.Calendar /> {formatDate(quotation.quotationDate)}
                                        </span>
                                    </td>
                                    <td style={styles.td}>
                                        {formatDate(quotation.validUntil)}
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <button
                                            style={styles.viewButton}
                                            onClick={() => {
                                                setSelectedQuotation(quotation);
                                                setShowPopup(true);
                                            }}
                                        >
                                            View Details
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="10" style={{ padding: 0 }}>
                                    <div style={styles.emptyState}>
                                        <Icons.NoData />
                                        <div style={styles.emptyStateText}>No quotations match the selected filter</div>
                                        <div style={styles.emptyStateSubtext}>Try adjusting your filter to see more results</div>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Popup for Quotation Details */}
            {showPopup && selectedQuotation && (
                <div style={styles.overlay} onClick={() => setShowPopup(false)}>
                    <div style={styles.popup} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.popupHeader}>
                            <h3 style={styles.popupTitle}>
                                <Icons.Enquiry /> Quotation Details - #{selectedQuotation.enquiryId}
                            </h3>
                            <button
                                style={styles.closeButton}
                                onClick={() => setShowPopup(false)}
                            >
                                <Icons.Close />
                            </button>
                        </div>

                        <div style={styles.vendorInfo}>
                            <Icons.Vendor />
                            <span><strong>Vendor:</strong> #{selectedQuotation.vendorId} - {selectedQuotation.vendorName}</span>
                            <span style={{ marginLeft: 'auto' }}>
                                <span style={{ ...styles.badge, ...getStatusBadge(selectedQuotation.status) }}>
                                    {getStatusLabel(selectedQuotation.status)}
                                </span>
                            </span>
                        </div>

                        {/* Per Plate Prices */}
                        <div style={styles.priceGrid}>
                            <div style={styles.priceCard}>
                                <div style={styles.priceLabel}><Icons.Veg /> Veg Per Plate</div>
                                <div style={styles.priceValue}>{formatCurrency(selectedQuotation.vegPerPlatePrice)}</div>
                            </div>
                            <div style={styles.priceCard}>
                                <div style={styles.priceLabel}><Icons.NonVeg /> Non-Veg Per Plate</div>
                                <div style={styles.priceValue}>{formatCurrency(selectedQuotation.nonVegPerPlatePrice)}</div>
                            </div>
                            <div style={styles.priceCard}>
                                <div style={styles.priceLabel}><Icons.Money /> Total Amount</div>
                                <div style={styles.priceValue}>{formatCurrency(calculateTotalQuotation(selectedQuotation))}</div>
                            </div>
                        </div>

                        {/* Quotation Details */}
                        <div style={{ marginBottom: '16px' }}>
                            <h4 style={styles.sectionTitle}>Quotation Details</h4>
                            <div style={styles.detailsBox}>
                                {selectedQuotation.quotationDetails}
                            </div>
                        </div>

                        {/* Add-On Prices */}
                        {selectedQuotation.addOnPrices.length > 0 && (
                            <div>
                                <h4 style={styles.sectionTitle}><Icons.AddOn /> Add-Ons</h4>
                                <table style={styles.addOnsTable}>
                                    <thead>
                                        <tr>
                                            <th style={styles.addOnsHeader}>Add-On Type</th>
                                            <th style={styles.addOnsHeader}>Qty</th>
                                            <th style={styles.addOnsHeader}>Unit Price</th>
                                            <th style={styles.addOnsHeader}>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedQuotation.addOnPrices.map((addon, index) => (
                                            <tr key={index}>
                                                <td style={styles.addOnsCell}>
                                                    {addon.addOnType.split('_').map(word =>
                                                        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                                                    ).join(' ')}
                                                </td>
                                                <td style={styles.addOnsCell}>{addon.quantity}</td>
                                                <td style={styles.addOnsCell}>{formatCurrency(addon.price)}</td>
                                                <td style={{ ...styles.addOnsCell, fontWeight: '600', color: 'rgb(230 109 51)' }}>
                                                    {formatCurrency(addon.totalAmount)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <button
                            style={styles.closePopupButton}
                            onClick={() => setShowPopup(false)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}

            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes slideUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px) scale(0.95);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0) scale(1);
                    }
                }

                @media (max-width: 768px) {
                    .stat-card {
                        flex: 1 1 calc(50% - 6px) !important;
                        min-width: 120px !important;
                    }
                    
                    .stat-value {
                        font-size: 16px !important;
                    }
                    
                    .stat-label {
                        font-size: 10px !important;
                    }
                    
                    .filter-select {
                        min-width: 120px !important;
                        font-size: 12px !important;
                        padding: 6px 10px !important;
                    }

                    .price-grid {
                        grid-template-columns: 1fr 1fr !important;
                    }
                }

                @media (max-width: 480px) {
                    .stat-card {
                        flex: 1 1 calc(50% - 4px) !important;
                        min-width: 80px !important;
                        padding: 6px 10px !important;
                    }
                    
                    .stat-icon {
                        width: 28px !important;
                        height: 28px !important;
                    }
                    
                    .stat-value {
                        font-size: 14px !important;
                    }
                    
                    .stat-label {
                        font-size: 9px !important;
                    }
                    
                    .table-container table {
                        font-size: 11px !important;
                    }
                    
                    .table-container table th,
                    .table-container table td {
                        padding: 6px 8px !important;
                        font-size: 10px !important;
                    }
                    
                    .badge {
                        font-size: 9px !important;
                        padding: 2px 8px !important;
                    }

                    .price-grid {
                        grid-template-columns: 1fr !important;
                    }

                    .popup {
                        padding: 16px !important;
                        max-width: 100% !important;
                    }

                    .popup-title {
                        font-size: 16px !important;
                    }
                }

                ::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                
                ::-webkit-scrollbar-thumb {
                    background: #c1c1c1;
                    border-radius: 4px;
                }
                
                ::-webkit-scrollbar-thumb:hover {
                    background: #a1a1a1;
                }
            `}</style>
        </div>
    );
};

export default VendorQuotations;